



















import { Component, Prop, Vue } from "vue-property-decorator";
@Component({ components: {} })
export default class confirm_delete_dialog extends Vue {
  @Prop({ type: Boolean, default: false }) public value!: boolean;
  @Prop({ type: Object, default: null }) public item!: any;
}
